module.exports = __webpack_public_path__ + "static/9 - Raptor 6-7f633dec44156463b28916d8f756a565.jpg";